export default __webpack_public_path__ + "assets/audios/98c5c3ce0f332bafea2dbbc6d814cb91.wav";